import React from "react";
import { useState } from "react";
import Modal from "./Modal";
const Card = ({ book }) => {

    const [show,setShow]=useState(false);
    const [bookItem,setItem]=useState();
    console.log(book)
    return (
        <>
            {
                book.map((item, index) => {
                    let thumbnail=item.volumeInfo.imageLinks && item.volumeInfo.imageLinks.smallThumbnail;
                    let amount=item.saleInfo.listPrice && item.saleInfo.listPrice.amount;
                    if(thumbnail!== undefined && amount !==undefined)
                    {
                        return (
                            <div key={item.id || index} className="card" onClick={()=>{setShow(true);setItem(item)}}>
                                <img src={thumbnail} alt={item.volumeInfo.title || "Book cover"} />
                                <div className="bottom">
                                    <h3 className="title">{item.volumeInfo.title}</h3>
                                    <p className="amount">&#8377;{amount}</p>
                                </div>
                            </div>
                        )
                    }
                    return null;
                })
            }
            <Modal show={show} item={bookItem} onClose={()=>setShow(false)}/>

        </>
    )
}
export default Card;